export default "__VITE_ASSET__BHZmi5zc__"